import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomSelect from "../../../../Components/CustomSelect";
import PercentIcon from "@mui/icons-material/Percent";

const Step5_RepaymentAndRecovery = ({
  earlyRepaymentOptions,
  earlyRepaymentPlanOptions,
  debtCollectionTypeOptions,
  recoveryOptions,
  rolloverFrequencyOptions,
  yesNoOptions,
}) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();

  const early_repayment = watch("early_repayment");
  const debt_collection = watch("debt_collection");
  const recovery = watch("recovery");
  const allow_rollover = watch("allow_rollover");

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="early_repayment"
          id="early_repayment"
          value={early_repayment || ""}
          label="Early repayment"
          onChange={(e) => setValue("early_repayment", e.target.value)}
          options={yesNoOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="early_repayment_plan"
          id="early_repayment_plan"
          value={watch("early_repayment_plan") || ""}
          label="Early repayment plan"
          onChange={(e) => setValue("early_repayment_plan", e.target.value)}
          options={earlyRepaymentPlanOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="debt_collection"
          id="debt_collection"
          value={debt_collection || ""}
          label="Debt collection"
          onChange={(e) => setValue("debt_collection", e.target.value)}
          options={yesNoOptions}
        />
      </Grid>

      {debt_collection === "YES" && (
        <>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.debt_collection_fee_p}>
              <InputLabel htmlFor="debt_collection_fee_p">
                Debt collection fee percentage
              </InputLabel>
              <OutlinedInput
                id="debt_collection_fee_p"
                type="number"
                {...register("debt_collection_fee_p")}
                label="Debt collection fee percentage"
                onWheel={(event) => event.target.blur()}
                inputProps={{ step: "any", min: 0 }}
                fullWidth
                defaultValue="0"
                endAdornment={
                  <InputAdornment position="end">
                    <PercentIcon />
                  </InputAdornment>
                }
              />
              {errors.debt_collection_fee_p && (
                <FormHelperText>Enter debt collection fee</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.days_to_debt_collection}>
              <InputLabel htmlFor="days_to_debt_collection">
                Days to debt collection
              </InputLabel>
              <OutlinedInput
                id="days_to_debt_collection"
                type="number"
                {...register("days_to_debt_collection")}
                label="Days to debt collection"
                onWheel={(event) => event.target.blur()}
                fullWidth
                defaultValue="0"
              />
              {errors.days_to_debt_collection && (
                <FormHelperText>Enter days to debt collection</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <CustomSelect
              labelId="debt_collection_type"
              id="debt_collection_type"
              value={watch("debt_collection_type") || ""}
              label="Debt collection type"
              onChange={(e) => setValue("debt_collection_type", e.target.value)}
              options={debtCollectionTypeOptions}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="recovery"
          id="recovery"
          value={recovery || ""}
          label="Recovery"
          onChange={(e) => setValue("recovery", e.target.value)}
          options={recoveryOptions}
        />
      </Grid>

      {recovery === "before_loan_end_date" && (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth error={!!errors.instalment_before_recovery}>
            <InputLabel htmlFor="instalment_before_recovery">
              Installment before recovery
            </InputLabel>
            <OutlinedInput
              id="instalment_before_recovery"
              type="number"
              {...register("instalment_before_recovery")}
              label="Installment before recovery"
              onWheel={(event) => event.target.blur()}
              inputProps={{ step: "any", min: 0 }}
              fullWidth
              defaultValue="0"
            />
            {errors.instalment_before_recovery && (
              <FormHelperText>Enter installment</FormHelperText>
            )}
          </FormControl>
        </Grid>
      )}

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="allow_rollover"
          id="allow_rollover"
          value={allow_rollover || ""}
          label="Allow Rollover"
          onChange={(e) => setValue("allow_rollover", e.target.value)}
          options={yesNoOptions}
        />
      </Grid>

      {allow_rollover === "YES" && (
        <>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.rollover_days}>
              <InputLabel htmlFor="rollover_days">Rollover days</InputLabel>
              <OutlinedInput
                id="rollover_days"
                type="number"
                {...register("rollover_days")}
                label="Rollover days"
                onWheel={(event) => event.target.blur()}
                inputProps={{ step: "any", min: 0 }}
                fullWidth
                defaultValue="0"
              />
              {errors.rollover_days && (
                <FormHelperText>Enter rollover days</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <CustomSelect
              labelId="rollover_frequency"
              id="rollover_frequency"
              value={watch("rollover_frequency") || ""}
              label="Rollover frequency"
              onChange={(e) => setValue("rollover_frequency", e.target.value)}
              options={rolloverFrequencyOptions}
              defaultValue=""
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.rollover_interest_rate}>
              <InputLabel htmlFor="rollover_interest_rate">
                Rollover interest rate
              </InputLabel>
              <OutlinedInput
                id="rollover_interest_rate"
                type="number"
                {...register("rollover_interest_rate")}
                label="Rollover interest rate"
                onWheel={(event) => event.target.blur()}
                inputProps={{ step: "any", min: 0 }}
                fullWidth
                defaultValue="0"
              />
              {errors.rollover_interest_rate && (
                <FormHelperText>Enter rollover interest rate</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.grace_period_b_rollover}>
              <InputLabel htmlFor="grace_period_b_rollover">
                Grace period before rollover
              </InputLabel>
              <OutlinedInput
                id="grace_period_b_rollover"
                type="number"
                {...register("grace_period_b_rollover")}
                label="Grace period before rollover"
                onWheel={(event) => event.target.blur()}
                inputProps={{ step: "any", min: 0 }}
                fullWidth
                defaultValue="0"
              />
              {errors.grace_period_b_rollover && (
                <FormHelperText>
                  Enter Grace period before rollover
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Step5_RepaymentAndRecovery;
